import { render, staticRenderFns } from "./ProductionReport.vue?vue&type=template&id=2b906d0c&"
import script from "./ProductionReport.vue?vue&type=script&lang=js&"
export * from "./ProductionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports